const InvestorStructureEnum = Object.freeze({
    INDIVIDUAL: 'INDIVIDUAL',
    TRUST: 'TRUST',
    CORPORATE: 'CORPORATE',
    PENSION: 'PENSION',
    JOINT: 'JOINT'
});

export default InvestorStructureEnum;
